import getUniqueId from 'app/utils/getUniqueId'
import {
    Column,
} from 'app/types/simpletable.types'
import ChipCheckMark from 'app/Apps/DomainObject/ComponentMapper/ChipCheckMark'
import {
    Company,
} from '../Companies.types'

export type CompanyDuplication = Pick<Company, 'companyName' | 'website' | 'awbPrefix' | 'archived'>

export default ({
    label, classes,
}): Column<keyof CompanyDuplication>[] => {
    return [
        {
            fieldName: 'companyName',
            label: label('Company.companyName'),
            id: getUniqueId(),
        },
        {
            fieldName: 'website',
            label: label('Company.website'),
            id: getUniqueId(),
        },
        {
            fieldName: 'awbPrefix',
            label: label('Company.awbPrefix'),
            id: getUniqueId(),
        },
        {
            fieldName: 'archived',
            label: label('Location.isArchived'),
            id: getUniqueId(),
            className: classes.archived,
            component: ChipCheckMark,
            getProps: ({
                archived,
            }) => {
                return {
                    value: archived,
                }
            },
        },
    ]
}
